export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14703.0720d7a3.jpg";